import { useChannelTalk } from '@repo/channel-talk';
import { Button, Description } from '@zenterprise-inc/ui';

import FillNoResultMoney from '@/assets/illust-icons/fill-no-resultmoney2.svg';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const ImpossibleContent = () => {
  const { openChannelTalk } = useChannelTalk();
  const handleClick = () => {
    openChannelTalk(SUPPORT_BOT_LINK.신청결과.환급불가);
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center pb-[108px]">
      <Description>
        <Description.Guide
          imgChild={<FillNoResultMoney />}
          subTitle={'국세청에서 환급이\n어렵다고 결정했어요'}
          description={'국세청 결정에 대한 자세한 사항은\n고객센터에 문의해주세요.'}
        />
        <Button.Box size="large" onClick={handleClick}>
          문의하기
        </Button.Box>
      </Description>
    </div>
  );
};

export default ImpossibleContent;
